module.exports = __webpack_public_path__ + "static/media/img-2.1f4809c4.png";